module.exports = __webpack_public_path__ + "static/media/012.adae8969.jpg";